export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5490.382c82a6.jpg";